import { heatList } from "@/mocks/homeContent";

export default function HeatBoard() {
  return (
    <section id="heat" className="w-full bg-background-100">
      <div className="container-x py-12 md:py-16">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-primary-600">
              <i className="ri-fire-fill" />
              扒皮现场热度
            </p>
            <h2 className="font-heading mt-2 text-2xl font-black md:text-4xl">现场热度榜</h2>
            <p className="mt-2 text-sm text-foreground-500">
              按当前深挖帖与起底档案的讨论热度排序，红标为正在取证的焦点事件。
            </p>
          </div>
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <span className="inline-flex h-2 w-2 rounded-full bg-primary-500 animate-pulse-dot" />
            热度每 6 小时刷新一次
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 lg:grid-cols-2">
          {heatList.map((it) => {
            const top = it.no === "01";
            return (
              <a
                key={it.no}
                href="#dig"
                className={`group flex items-center gap-4 rounded-lg border p-4 transition-colors md:p-5 ${
                  top
                    ? "border-primary-300 bg-background-50 ring-1 ring-primary-200"
                    : "border-background-200 bg-background-50 hover:border-background-300"
                }`}
              >
                <span
                  className={`font-heading shrink-0 text-3xl font-black md:text-4xl ${
                    top ? "text-primary-500" : "text-foreground-200 group-hover:text-accent-500"
                  }`}
                >
                  {it.no}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span
                      className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold ${
                        top
                          ? "bg-primary-100 text-primary-800"
                          : "bg-secondary-100 text-secondary-900"
                      }`}
                    >
                      {it.tag}
                    </span>
                    <span className="inline-flex items-center gap-1 text-[11px] text-foreground-400">
                      <i className="ri-focus-2-line" />
                      {it.phase}
                    </span>
                  </div>
                  <h3 className="mt-1.5 truncate text-sm font-semibold text-foreground-950 md:text-base">
                    {it.title}
                  </h3>
                  <div className="mt-2 flex items-center gap-2">
                    <div className="h-1.5 w-full max-w-[180px] overflow-hidden rounded-full bg-secondary-100">
                      <div
                        className={`h-full rounded-full ${top ? "bg-primary-500" : "bg-accent-500"}`}
                        style={{ width: `${it.heat}%` }}
                      />
                    </div>
                    <span className="text-xs font-bold text-accent-600">{it.heat}</span>
                  </div>
                </div>
                <i className="ri-arrow-right-up-line shrink-0 text-lg text-foreground-300 transition-transform group-hover:translate-x-0.5 group-hover:text-primary-500" />
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}